import { SortedCatalog } from "../components/SortedCatalog";
import { interactiveDefinitions } from "./interactiveDefinitions";
import { InteractiveCard } from "./InteractiveCard";

export function InteractiveCatalog({ limit }: { limit?: number }) {
  return (
    <SortedCatalog
      items={interactiveDefinitions}
      label="Sort interactives"
      limit={limit}
      renderItem={(item) => (
        <InteractiveCard
          heading={limit ? "h3" : "h2"}
          key={item.name}
          interactive={item}
          to={`/interactives/${item.name}`}
        />
      )}
    />
  );
}
